import { IDropdownResponse } from './../models/util';
import axios, { AxiosResponse } from 'axios';

import { IFileUseType } from '../models';
import { authFetch } from './fetch';

const baseUrl = '/api/Admin/FileUseTypes';

/**
 * Simplified CRUD/network ops interface for `IFileUseType` resources.
 */
export const FileUseTypeAPI = {
  async getAll(): Promise<IFileUseType[]> {
    try {
      const response: AxiosResponse<IFileUseType[]> = await authFetch.get(baseUrl);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

  async upsert(upsertData: IFileUseType[]): Promise<IFileUseType[]> {
    try {
      const response: AxiosResponse<IFileUseType[]> = await authFetch.post(baseUrl, upsertData);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

  async delete(bankAccountId: number): Promise<void> {
    try {
      const response = await authFetch.delete(`${baseUrl}/${bankAccountId}`);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
    }
  },
};

export const getFileTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await authFetch.get(`${baseUrl}/FileTypes`);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getEntityTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await authFetch.get(`${baseUrl}/EntityTypes`);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
